import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  GET_PROPOSAL_MILESTONE_TEMPLATE: createSagaAction('GET_PROPOSAL_MILESTONE_TEMPLATE'),
  GET_PROPOSAL_MILESTONE: createSagaAction('GET_PROPOSAL_MILESTONE'),
  SET_TEMPORARY_SAVED_PROPOSAL_MILESTONES_DATA: createSagaAction(
    'SET_TEMPORARY_SAVED_PROPOSAL_MILESTONES_DATA'
  )
}

// Action Creators
export const actions = {
  getProposalMilestoneTemplate: ({ templateId }) => ({
    type: constants.GET_PROPOSAL_MILESTONE_TEMPLATE.ACTION,
    templateId
  }),

  getProposalMilestone: ({ proposalId }) => ({
    type: constants.GET_PROPOSAL_MILESTONE.ACTION,
    proposalId
  }),

  setTemporaryProposalMilestonesData: row => ({
    type: constants.SET_TEMPORARY_SAVED_PROPOSAL_MILESTONES_DATA.ACTION,
    row
  })
}

// Reducer
const initialState = []

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    default:
      return state
    case constants.GET_PROPOSAL_MILESTONE_TEMPLATE.SUCCESS:
      return { ...state, proposalMilestonesTemplate: action.payload }
    case constants.GET_PROPOSAL_MILESTONE.SUCCESS:
      return { ...state, proposalMilestones: action.payload }

    case constants.SET_TEMPORARY_SAVED_PROPOSAL_MILESTONES_DATA.ACTION: {
      return {
        ...state,
        error: null,
        loading: false,
        proposalMilestones: { data: action.row.proposalMilestones }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/proposalActions.js